import React from 'react';

export default function Heading3({ heading }) {
  return (
    <h3 className="text-xl font-medium tracking-wide leading-relaxed text-zinc-800">
      {heading}
    </h3>
  );
}
